import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { RouterModal } from "@/components/General/Modal/routerModal";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CheckUserSelectors from "@/redux/modules/api/data/checkUser/checkUser.selectors";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as HasAccountModalUserDataModule from "@/redux/modules/value/hasAccountModalUserData/hasAccountModalUserData.module";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import * as SoftLoginService from "@/services/softLogin.service";
import { Config } from "@/utils/config.utils";
import { StorageKeys } from "@/utils/enums";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

type Props = {
    className?: string;
};

export const HasAccountModal = ({ className }: Props) => {
    const { t } = useGranite();

    const dispatch = useThunkDispatch();

    const checkUser = useSelector(CheckUserSelectors.doesUserExist);
    const userUrl = useSelector(CheckUserSelectors.fetchUserUrl);

    const { close: closeModal } = useModalRouter(ModalType.HasAccount);

    const email =
        checkUser && userUrl
            ? userUrl.substring(userUrl.lastIndexOf("/") + 1)
            : undefined;

    const loginAsGuest = () => {
        sessionStorage.setItem(StorageKeys.GuestEmail, email);

        dispatch(CustomerModule.registerGuest(email)).then((action) => {
            if (action.type === CustomerModule.APIStatus.SUCCESS) {
                SoftLoginService.clearSoftLogin();
                location.assign(Config.pages["checkout-account"]);
            }
        });
    };

    const handleOnConfirm = () => {
        dispatch(HasAccountModalUserDataModule.set({ email }));

        SoftLoginService.clearSoftLogin();
        SoftLoginService.setSoftLogin(email);

        closeModal();
    };

    const handleOnCancel = () => {
        loginAsGuest();

        closeModal();
    };

    return (
        <RouterModal
            className={cn(className)}
            modalType={ModalType.HasAccount}
            title={t("modal.has-account.title")}
            cancelButtonText={t("modal.hasAccountModal.button.proceedAsGuest")}
            confirmButtonText={t("modal.hasAccountModal.button.login")}
            confirmButtonColor={"primary"}
            withFooter={true}
            onConfirm={handleOnConfirm}
            onCancel={handleOnCancel}
        >
            <p className={cn("revert-legacy")}>
                {t("modal.has-account.description.email", email)}
            </p>
            <p className={cn("revert-legacy", "tw:mb-4")}>
                {t("modal.has-account.description.continue")}
            </p>
        </RouterModal>
    );
};
